/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { UnistylesRuntime } from 'react-native-unistyles';

export const breakpoints = {
  xs: 0,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
  superLarge: 5,
  tvLike: 6,
};

export const getCurrentBreakpoint = () => {
  const currentBreakpoint = UnistylesRuntime.breakpoint;
  return (
    breakpoints[currentBreakpoint as keyof typeof breakpoints] ?? breakpoints.md
  );
};
